module.exports = __webpack_public_path__ + "media/images/shop/photo_large2-ef3c6bced54b395e7b06fc208967e055.jpg";